import React from 'react';
import { Smartphone, Code, Database, TestTube, GitBranch } from 'lucide-react';
import { skills } from '../../data/skills';

const SkillsSection: React.FC = () => {
  const getIcon = (iconName: string) => {
    const iconMap = {
      Smartphone: <Smartphone className="w-6 h-6" />,
      Code: <Code className="w-6 h-6" />,
      Database: <Database className="w-6 h-6" />,
      TestTube: <TestTube className="w-6 h-6" />,
      GitBranch: <GitBranch className="w-6 h-6" />
    };
    return iconMap[iconName as keyof typeof iconMap] || null;
  };
  return (
    <section id="skills" className="py-20">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="spotlight inline-block text-3xl sm:text-4xl md:text-5xl font-bold mb-6 pb-2 leading-tight bg-gradient-to-r from-emerald-400 to-gold-400 bg-clip-text text-transparent animate-fade-in-up">
            Technical Skills
          </h2>
          <p className="text-lg sm:text-xl text-slate-300 animate-fade-in-up" style={{animationDelay: '0.2s'}}>
            Full-stack toolkit spanning backend systems, mobile apps, and production infrastructure
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {skills.map((skillCategory, index) => (
            <div
              key={index}
              className="lit-card rounded-2xl p-5 sm:p-6 transition-all duration-300 transform hover:-translate-y-1.5 animate-fade-in-up cursor-pointer"
              style={{animationDelay: `${index * 0.1}s`}}
            >
              <div className="flex items-center mb-4">
                <div className="text-emerald-400 mr-3 drop-shadow-[0_0_10px_rgba(16,185,129,0.5)]">{getIcon(skillCategory.icon)}</div>
                <h3 className="text-lg sm:text-xl font-semibold">
                  {skillCategory.category}
                </h3>
              </div>
              <div className="space-y-2">
                {skillCategory.items.map((skill, skillIndex) => (
                  <div key={skillIndex} className="flex items-center transform hover:translate-x-2 transition-transform duration-200 cursor-pointer group">
                    <div className="w-2 h-2 bg-gradient-to-r from-emerald-400 to-gold-400 rounded-full mr-3 animate-pulse group-hover:scale-125 transition-transform duration-200"></div>
                    <span className="text-slate-300 text-sm sm:text-base group-hover:text-emerald-300 transition-colors duration-200">{skill}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;